import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const Contracts = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_VEHICLE.FETCH_VEHICLE_LIST:
      return { ...state, contractList: action.value };
    case actions.FETCH_VEHICLE_CONTRACTS:
      return { ...state, vehicleAllContracts: action.value };
    case actions.CONTRACT_TYPE:
      return { ...state, contractType: action.value };
    case actions.REFRESH_UPLIFT:
      return { ...state, refreshUpliftStatus: action.value };
    case actions.SUBSCRIPTION_PLAN_DETAILS:
      return {
        ...state,
        subscriptonPlansDetail: action.value,
      };
    case actions.CONTRACT_STATE_DATA:
      return {
        ...state,
        contractStateData: action.value,
      };
    default:
      return state;
  }
};
export default Contracts;
